<template>
  <div class="biz-chart-box">
    <div class="chart-title">
      <img class="charts-icon" :src="require('@/assets/images/largescreen/charts-icon.png')" alt="">
      <dv-decoration-1 />
      <span>分等级终端装机情况</span>
    </div>
    <div ref="chart" class="biz-chart-container"></div>
  </div>
</template>

<script>
import resize from '@/utils/resize'

export default {
  name: 'BizLevelInstall',
  mixins: [resize],
  props: {
    chartData: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    chartData: {
      handler(v) {
        if (v && v.length) this.initChart()
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.chartData && this.chartData.length) this.initChart()
    })
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose()
      this.chart = null
    }
  },
  methods: {
    initChart() {
      if (!this.$refs.chart) return
      if (this.chart) {
        this.chart.dispose()
      }
      this.chart = this.$echarts.init(this.$refs.chart)
      const data = this.chartData
      const regions = data.map(d => d.region || '')
      const level3 = data.map(d => d['三级'] || 0)
      const level2 = data.map(d => d['二级'] || 0)
      const level1 = data.map(d => d['一级'] || 0)
      const levelUnknown = data.map(d => d['未定级'] || 0)
      const option = {
        color: ['#24CBF1', '#868EF9', '#E6A23C', '#909399'],
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: '#00f2fe',
          textStyle: { color: '#fff' }
        },
        legend: {
          data: ['三级医院', '二级医院', '一级医院', '未定级'],
          textStyle: { color: '#fff', fontSize: 11 },
          top: 0
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '15%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: regions,
          axisLabel: { color: '#fff', fontSize: 11, interval: 0, rotate: regions.length > 6 ? 30 : 0 },
          axisLine: { lineStyle: { color: 'rgba(255,255,255,0.3)' } }
        },
        yAxis: {
          type: 'value',
          name: '装机家数',
          nameTextStyle: { color: '#fff', fontSize: 11 },
          axisLabel: { color: '#fff', fontSize: 11 },
          splitLine: { lineStyle: { color: 'rgba(255,255,255,0.1)' } },
          axisLine: { lineStyle: { color: 'rgba(255,255,255,0.3)' } }
        },
        series: [
          {
            name: '三级医院',
            type: 'line',
            data: level3,
            smooth: true,
            itemStyle: { color: '#24CBF1' },
            lineStyle: { width: 3 },
            symbol: 'circle',
            symbolSize: 8,
            areaStyle: {
              color: {
                type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(36, 203, 241, 0.3)' },
                  { offset: 1, color: 'rgba(36, 203, 241, 0.05)' }
                ]
              }
            }
          },
          {
            name: '二级医院',
            type: 'line',
            data: level2,
            smooth: true,
            itemStyle: { color: '#868EF9' },
            lineStyle: { width: 3 },
            symbol: 'circle',
            symbolSize: 8,
            areaStyle: {
              color: {
                type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(134, 142, 249, 0.3)' },
                  { offset: 1, color: 'rgba(134, 142, 249, 0.05)' }
                ]
              }
            }
          },
          {
            name: '一级医院',
            type: 'line',
            data: level1,
            smooth: true,
            itemStyle: { color: '#E6A23C' },
            lineStyle: { width: 3 },
            symbol: 'circle',
            symbolSize: 8,
            areaStyle: {
              color: {
                type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(230, 162, 60, 0.3)' },
                  { offset: 1, color: 'rgba(230, 162, 60, 0.05)' }
                ]
              }
            }
          },
          {
            name: '未定级',
            type: 'line',
            data: levelUnknown,
            smooth: true,
            itemStyle: { color: '#909399' },
            lineStyle: { width: 3, type: 'dashed' },
            symbol: 'circle',
            symbolSize: 8,
            areaStyle: {
              color: {
                type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(144, 147, 153, 0.3)' },
                  { offset: 1, color: 'rgba(144, 147, 153, 0.05)' }
                ]
              }
            }
          }
        ]
      }
      this.chart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.biz-chart-box {
  background: rgba(10, 57, 130, 0.6);
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .chart-title {
    display: flex;
    align-items: center;
    color: #fff;
    font-weight: bolder;
    padding: 8px 15px;
    background: rgba(10, 57, 130, 0.6);
    position: relative;
    flex-shrink: 0;

    .charts-icon {
      width: 20px;
      height: 25px;
      position: absolute;
      left: 15px;
      top: 50%;
      transform: translateY(-50%);
    }

    .dv-decoration-1 {
      width: 60px;
      height: 20px;
      margin-left: 40px;
    }

    span {
      margin-left: 10px;
      font-size: 16px;
    }
  }

  .biz-chart-container {
    flex: 1;
    width: 100%;
    min-height: 0;
  }
}
</style>
